import Button from 'observian-ui/lib/button'
import ContactModal from 'observian-ui/lib/modal/contact'
import { useState } from 'react'

import ContactForm from 'components/Form/Contact'

import style from './providedServices.module.css'

const ProvidedServices = () => {
  const [showModal, setShowModal] = useState(false)
  const [isSuccessful, setIsSuccessful] = useState(false)

  return (
    <section className={style.section}>
      <div className={style.top} />
      <div className={style.contentContainer}>
        <div className={style.content}>
          <div className={style.right}>
            <svg viewBox="0 0 1241 401" className={style.cloudSVG}>
              <defs>
                <linearGradient
                  x1="35.5076913%"
                  y1="71.4267185%"
                  x2="60.0395994%"
                  y2="39.9870298%"
                  id="a"
                >
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="48.5642548%"
                  y1="84.1463415%"
                  x2="59.342314%"
                  y2="-33.6807095%"
                  id="b"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="c">
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="17.2353456%"
                  y1="53.9645507%"
                  x2="105.395159%"
                  y2="20.6872982%"
                  id="d"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#B1B8BF" offset="15%" />
                  <stop stopColor="#C6CACF" offset="32%" />
                  <stop stopColor="#D6D8DA" offset="50%" />
                  <stop stopColor="#DFE0E0" offset="70%" />
                  <stop stopColor="#E2E2E2" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="-6.10982212%"
                  y1="50.1100578%"
                  x2="147.177108%"
                  y2="47.7163009%"
                  id="e"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="f">
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="50.0235516%" x2="100%" y2="50.0235516%" id="g">
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="h">
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="118.919861%"
                  y1="107.665329%"
                  x2="41.8466899%"
                  y2="34.0784822%"
                  id="i"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="-12.2652817%"
                  y1="56.646%"
                  x2="92.9684379%"
                  y2="48.1970257%"
                  id="j"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="14.2431022%"
                  y1="70.6968419%"
                  x2="104.623415%"
                  y2="38.6711045%"
                  id="k"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="-2.31958763%"
                  y1="77.5299359%"
                  x2="77.6202749%"
                  y2="-18.2673799%"
                  id="l"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A6AFB9" offset="17%" />
                  <stop stopColor="#C3C8CE" offset="50%" />
                  <stop stopColor="#D4D8DB" offset="79%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="54.899549%"
                  y1="75.3806575%"
                  x2="42.9274293%"
                  y2="43.6955272%"
                  id="m"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="26.9996935%"
                  y1="38.3635547%"
                  x2="58.7802636%"
                  y2="61.5347282%"
                  id="n"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="-58.6883236%"
                  y1="59.7387754%"
                  x2="58.9947901%"
                  y2="46.0650021%"
                  id="o"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="48.3258273%"
                  y1="84.1655864%"
                  x2="50.0489524%"
                  y2="43.5309422%"
                  id="p"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="48.8812078%"
                  y1="100.692802%"
                  x2="55.8400183%"
                  y2="-23.6397432%"
                  id="q"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="85.1243105%"
                  y1="88.0496637%"
                  x2="52.0309975%"
                  y2="10.3466115%"
                  id="r"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="42.0196056%"
                  y1="91.7672887%"
                  x2="69.5605854%"
                  y2="-48.8748628%"
                  id="s"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="85.6605548%"
                  y1="56.3690077%"
                  x2="26.7748002%"
                  y2="35.9845591%"
                  id="t"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="53.6154776%"
                  y1="57.5175727%"
                  x2="43.5550181%"
                  y2="32.82291%"
                  id="u"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="143.51733%"
                  y1="44.239703%"
                  x2="51.6688062%"
                  y2="53.9249624%"
                  id="v"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#B1B8BF" offset="15%" />
                  <stop stopColor="#C6CACF" offset="32%" />
                  <stop stopColor="#D6D8DA" offset="50%" />
                  <stop stopColor="#DFE0E0" offset="70%" />
                  <stop stopColor="#E2E2E2" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="87.2913992%"
                  y1="86.1366486%"
                  x2="17.0089859%"
                  y2="-11.4137393%"
                  id="w"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="44.1650184%"
                  y1="64.5707129%"
                  x2="65.9790901%"
                  y2="10.0693711%"
                  id="x"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="-24.4834711%"
                  y1="32.1762303%"
                  x2="83.3677686%"
                  y2="74.2537011%"
                  id="y"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="99.9672239%"
                  y1="95.908347%"
                  x2="52.8930974%"
                  y2="62.2258592%"
                  id="z"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="75.3198683%"
                  y1="60.4519774%"
                  x2="9.25143368%"
                  y2="21.7296827%"
                  id="A"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="94.9423856%"
                  y1="92.4756035%"
                  x2="57.7627757%"
                  y2="23.2408834%"
                  id="B"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="80.1646091%"
                  y1="42.1671832%"
                  x2="26.9410151%"
                  y2="52.1898198%"
                  id="C"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="78.3005017%"
                  y1="49.3975904%"
                  x2="-86.8898198%"
                  y2="132.078313%"
                  id="D"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="54.0921091%"
                  y1="65.6752427%"
                  x2="-1.58404224%"
                  y2="-1.10045958%"
                  id="E"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#B2BAC2" offset="26%" />
                  <stop stopColor="#C8CDD3" offset="52%" />
                  <stop stopColor="#D5D9DD" offset="77%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="95.8643326%"
                  y1="21.1779132%"
                  x2="25.0765864%"
                  y2="64.2635493%"
                  id="F"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="50.4123178%"
                  y1="89.8215919%"
                  x2="49.8480935%"
                  y2="9.01189387%"
                  id="G"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="30.34505%"
                  y1="89.6036387%"
                  x2="79.7484682%"
                  y2="31.0033869%"
                  id="H"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="50.4608295%"
                  y1="64.3158932%"
                  x2="40.3801843%"
                  y2="19.896184%"
                  id="I"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="40.6729666%"
                  y1="82.8396107%"
                  x2="53.5392761%"
                  y2="24.2699958%"
                  id="J"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="32.5171622%"
                  y1="-1.72413793%"
                  x2="82.6131037%"
                  y2="87.2563718%"
                  id="K"
                >
                  <stop stopColor="#ABB4BD" offset="0%" />
                  <stop stopColor="#BFC5CC" offset="18%" />
                  <stop stopColor="#CED3D7" offset="40%" />
                  <stop stopColor="#D7DBDE" offset="64%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="78.0344203%"
                  y1="58.7628793%"
                  x2="-24.0942029%"
                  y2="-0.545601223%"
                  id="L"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="65.6313302%"
                  y1="71.2837741%"
                  x2="-69.480081%"
                  y2="-91.5184277%"
                  id="M"
                >
                  <stop stopColor="#95A0AC" offset="0%" />
                  <stop stopColor="#A9B1BB" offset="12%" />
                  <stop stopColor="#BEC5CB" offset="29%" />
                  <stop stopColor="#CED2D7" offset="48%" />
                  <stop stopColor="#D7DADE" offset="69%" />
                  <stop stopColor="#DADDE0" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="22.3345704%"
                  y1="67.007535%"
                  x2="114.927159%"
                  y2="22.5511302%"
                  id="N"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <path
                  id="O"
                  d="M0.25704 216.400275L3.045735 202.837635 29.139075 193.967865 43.537095 146.891745 73.47564 142.272585 91.817145 113.058855 115.34292 85.62645 106.64514 58.857435 135.478035 18.415215 173.905515 1.25307 199.016055 0.061425 209.141799 20.7055828 222.996375 28.91889 237.50496 22.592115 261.70641 39.545415 293.143725 21.47418 305.8587 25.77393 314.80218 20.061405 335.80953 36.16704 327.87342 54.852525 348.303375 93.29229 302.750595 149.58216 257.517225 170.0244 186.6942 194.876955 159.959313 215.18406 110.294464 237.02679 34.569045 220.454325 8.78283 241.609095 1.97694 237.02679z"
                />
                <linearGradient x1="46.1451739%" y1="50%" x2="28.4016998%" y2="50%" id="Q">
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="68.8058278%"
                  y1="66.9699833%"
                  x2="36.458243%"
                  y2="37.7820126%"
                  id="R"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <linearGradient x1="100%" y1="50%" x2="-0.346921075%" y2="50%" id="S">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="50.0105686%" x2="100%" y2="50.0105686%" id="T">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="44.2459457%"
                  y1="50.0075109%"
                  x2="28.9307085%"
                  y2="50.0075109%"
                  id="U"
                >
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="67.3662302%"
                  y1="67.5258016%"
                  x2="37.6463446%"
                  y2="37.5216293%"
                  id="V"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="64.3656231%"
                  y1="64.2609951%"
                  x2="41.791692%"
                  y2="41.8479986%"
                  id="W"
                >
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" stopOpacity={0.6} offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="99.2888118%"
                  y1="50.0105686%"
                  x2="0.312228968%"
                  y2="50.0105686%"
                  id="X"
                >
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient x1="43.7998613%" y1="50%" x2="22.5026015%" y2="50%" id="Y">
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="67.1609435%"
                  y1="67.567685%"
                  x2="37.6430801%"
                  y2="37.3429572%"
                  id="Z"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <linearGradient x1="98.7513007%" y1="50%" x2="-0.0346860909%" y2="50%" id="aa">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient x1="33.1599029%" y1="50%" x2="-0.320846341%" y2="50%" id="ab">
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="68.3836282%"
                  y1="67.5227622%"
                  x2="37.0447451%"
                  y2="37.6439494%"
                  id="ac"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <linearGradient x1="98.7513007%" y1="50%" x2="0.554977454%" y2="50%" id="ad">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient x1="39.1692681%" y1="50%" x2="2.18522373%" y2="50%" id="ae">
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="67.6985779%"
                  y1="67.6779638%"
                  x2="37.7037808%"
                  y2="37.7140404%"
                  id="af"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <linearGradient x1="97.0863684%" y1="50%" x2="0.225459591%" y2="50%" id="ag">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient x1="39.4207423%" y1="50%" x2="8.43739161%" y2="50%" id="ah">
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="65.7127992%"
                  y1="68.3485823%"
                  x2="38.8831079%"
                  y2="37.0225891%"
                  id="ai"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="60.9001041%"
                  y1="59.1430052%"
                  x2="42.4210891%"
                  y2="43.6451984%"
                  id="aj"
                >
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" stopOpacity={0.6} offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="98.2310094%"
                  y1="49.9894314%"
                  x2="0.450919181%"
                  y2="49.9894314%"
                  id="ak"
                >
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient x1="38.8570933%" y1="50%" x2="0.47693375%" y2="50%" id="al">
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="68.9386056%"
                  y1="67.4626842%"
                  x2="36.7932709%"
                  y2="37.819177%"
                  id="am"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="98.7513007%"
                  y1="49.9894314%"
                  x2="0.0520291363%"
                  y2="49.9894314%"
                  id="an"
                >
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient x1="43.4530003%" y1="50%" x2="0.910509886%" y2="50%" id="ao">
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="67.5251474%"
                  y1="67.0421379%"
                  x2="37.4002775%"
                  y2="37.7440795%"
                  id="ap"
                >
                  <stop stopColor="#00EBAD" offset="0%" />
                  <stop stopColor="#1D8DBA" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="57.8997572%"
                  y1="59.1919404%"
                  x2="41.9441554%"
                  y2="40.6278255%"
                  id="aq"
                >
                  <stop stopColor="#162A40" stopOpacity={0} offset="0%" />
                  <stop stopColor="#162A40" stopOpacity={0.28} offset="42%" />
                  <stop stopColor="#162A40" stopOpacity={0.6} offset="100%" />
                </linearGradient>
                <linearGradient x1="98.0055498%" y1="50%" x2="0.138744364%" y2="50%" id="ar">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.01} offset="25%" />
                  <stop stopColor="#FFF" stopOpacity={0.06} offset="47%" />
                  <stop stopColor="#FFF" stopOpacity={0.13} offset="68%" />
                  <stop stopColor="#FFF" stopOpacity={0.23} offset="88%" />
                  <stop stopColor="#FFF" stopOpacity={0.3} offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="2.11997642e-05%"
                  y1="50.0078301%"
                  x2="100%"
                  y2="50.0078301%"
                  id="as"
                >
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.02} offset="12%" />
                  <stop stopColor="#FFF" stopOpacity={0.07} offset="24%" />
                  <stop stopColor="#FFF" stopOpacity={0.15} offset="37%" />
                  <stop stopColor="#FFF" stopOpacity={0.26} offset="50%" />
                  <stop stopColor="#FFF" stopOpacity={0.41} offset="63%" />
                  <stop stopColor="#FFF" stopOpacity={0.6} offset="76%" />
                  <stop stopColor="#FFF" stopOpacity={0.81} offset="89%" />
                  <stop stopColor="#FFF" offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="49.9477944%" x2="100%" y2="49.9477944%" id="at">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.02} offset="12%" />
                  <stop stopColor="#FFF" stopOpacity={0.07} offset="24%" />
                  <stop stopColor="#FFF" stopOpacity={0.15} offset="37%" />
                  <stop stopColor="#FFF" stopOpacity={0.26} offset="50%" />
                  <stop stopColor="#FFF" stopOpacity={0.41} offset="63%" />
                  <stop stopColor="#FFF" stopOpacity={0.6} offset="76%" />
                  <stop stopColor="#FFF" stopOpacity={0.81} offset="89%" />
                  <stop stopColor="#FFF" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="2.11997642e-05%"
                  y1="49.9417829%"
                  x2="100%"
                  y2="49.9417829%"
                  id="au"
                >
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.02} offset="12%" />
                  <stop stopColor="#FFF" stopOpacity={0.07} offset="24%" />
                  <stop stopColor="#FFF" stopOpacity={0.15} offset="37%" />
                  <stop stopColor="#FFF" stopOpacity={0.26} offset="50%" />
                  <stop stopColor="#FFF" stopOpacity={0.41} offset="63%" />
                  <stop stopColor="#FFF" stopOpacity={0.6} offset="76%" />
                  <stop stopColor="#FFF" stopOpacity={0.81} offset="89%" />
                  <stop stopColor="#FFF" offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="49.9320996%" x2="100%" y2="49.9320996%" id="av">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.02} offset="12%" />
                  <stop stopColor="#FFF" stopOpacity={0.07} offset="24%" />
                  <stop stopColor="#FFF" stopOpacity={0.15} offset="37%" />
                  <stop stopColor="#FFF" stopOpacity={0.26} offset="50%" />
                  <stop stopColor="#FFF" stopOpacity={0.41} offset="63%" />
                  <stop stopColor="#FFF" stopOpacity={0.6} offset="76%" />
                  <stop stopColor="#FFF" stopOpacity={0.81} offset="89%" />
                  <stop stopColor="#FFF" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="2.11997642e-05%"
                  y1="49.9960582%"
                  x2="100%"
                  y2="49.9960582%"
                  id="aw"
                >
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.02} offset="12%" />
                  <stop stopColor="#FFF" stopOpacity={0.07} offset="24%" />
                  <stop stopColor="#FFF" stopOpacity={0.15} offset="37%" />
                  <stop stopColor="#FFF" stopOpacity={0.26} offset="50%" />
                  <stop stopColor="#FFF" stopOpacity={0.41} offset="63%" />
                  <stop stopColor="#FFF" stopOpacity={0.6} offset="76%" />
                  <stop stopColor="#FFF" stopOpacity={0.81} offset="89%" />
                  <stop stopColor="#FFF" offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="50.0382773%" x2="100%" y2="50.0382773%" id="ax">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.02} offset="12%" />
                  <stop stopColor="#FFF" stopOpacity={0.07} offset="24%" />
                  <stop stopColor="#FFF" stopOpacity={0.15} offset="37%" />
                  <stop stopColor="#FFF" stopOpacity={0.26} offset="50%" />
                  <stop stopColor="#FFF" stopOpacity={0.41} offset="63%" />
                  <stop stopColor="#FFF" stopOpacity={0.6} offset="76%" />
                  <stop stopColor="#FFF" stopOpacity={0.81} offset="89%" />
                  <stop stopColor="#FFF" offset="100%" />
                </linearGradient>
                <linearGradient x1="0%" y1="49.9557913%" x2="100%" y2="49.9557913%" id="ay">
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.02} offset="12%" />
                  <stop stopColor="#FFF" stopOpacity={0.07} offset="24%" />
                  <stop stopColor="#FFF" stopOpacity={0.15} offset="37%" />
                  <stop stopColor="#FFF" stopOpacity={0.26} offset="50%" />
                  <stop stopColor="#FFF" stopOpacity={0.41} offset="63%" />
                  <stop stopColor="#FFF" stopOpacity={0.6} offset="76%" />
                  <stop stopColor="#FFF" stopOpacity={0.81} offset="89%" />
                  <stop stopColor="#FFF" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="-1.39390434e-13%"
                  y1="50.0082835%"
                  x2="100%"
                  y2="50.0082835%"
                  id="az"
                >
                  <stop stopColor="#FFF" stopOpacity={0} offset="0%" />
                  <stop stopColor="#FFF" stopOpacity={0.02} offset="12%" />
                  <stop stopColor="#FFF" stopOpacity={0.07} offset="24%" />
                  <stop stopColor="#FFF" stopOpacity={0.15} offset="37%" />
                  <stop stopColor="#FFF" stopOpacity={0.26} offset="50%" />
                  <stop stopColor="#FFF" stopOpacity={0.41} offset="63%" />
                  <stop stopColor="#FFF" stopOpacity={0.6} offset="76%" />
                  <stop stopColor="#FFF" stopOpacity={0.81} offset="89%" />
                  <stop stopColor="#FFF" offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="100.968882%"
                  y1="50%"
                  x2="-16.1446365%"
                  y2="50.3455292%"
                  id="aA"
                >
                  <stop stopColor="#FFC42A" offset="0%" />
                  <stop stopColor="#FF0061" stopOpacity={0.946473053} offset="100%" />
                </linearGradient>
                <linearGradient
                  x1="12.4534884%"
                  y1="75.3650874%"
                  x2="87.8953488%"
                  y2="25.5456024%"
                  id="aB"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-30.4%"
                  y="-35.7%"
                  width="160.8%"
                  height="171.4%"
                  filterUnits="objectBoundingBox"
                  id="aC"
                >
                  <feGaussianBlur stdDeviation={12.285} in="SourceGraphic" />
                </filter>
                <linearGradient
                  x1="12.4534884%"
                  y1="71.4653639%"
                  x2="87.8953488%"
                  y2="29.305313%"
                  id="aD"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-56.4%"
                  y="-71.9%"
                  width="212.8%"
                  height="243.8%"
                  filterUnits="objectBoundingBox"
                  id="aE"
                >
                  <feGaussianBlur stdDeviation={12.285} in="SourceGraphic" />
                </filter>
                <linearGradient
                  x1="12.4534884%"
                  y1="57.8957191%"
                  x2="87.8953488%"
                  y2="42.3877631%"
                  id="aF"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-30.5%"
                  y="-64.1%"
                  width="161.0%"
                  height="228.2%"
                  filterUnits="objectBoundingBox"
                  id="aG"
                >
                  <feGaussianBlur stdDeviation={12.285} in="SourceGraphic" />
                </filter>
                <linearGradient
                  x1="12.4534884%"
                  y1="65.0907733%"
                  x2="87.8953488%"
                  y2="35.4510349%"
                  id="aH"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-65.1%"
                  y="-99.0%"
                  width="230.2%"
                  height="298.0%"
                  filterUnits="objectBoundingBox"
                  id="aI"
                >
                  <feGaussianBlur stdDeviation={12.285} in="SourceGraphic" />
                </filter>
                <linearGradient
                  x1="12.4534884%"
                  y1="54.6754662%"
                  x2="87.8953488%"
                  y2="45.4923984%"
                  id="aJ"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
                <filter
                  x="-19.6%"
                  y="-53.5%"
                  width="139.1%"
                  height="206.9%"
                  filterUnits="objectBoundingBox"
                  id="aK"
                >
                  <feGaussianBlur stdDeviation={12.285} in="SourceGraphic" />
                </filter>
              </defs>
              <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <g transform="matrix(-1 0 0 1 1241 27) translate(406.593 29.421)">
                  <path
                    fill="#E2E2E2"
                    d="M440.282115 107.039205L443.402505 71.240715 414.7416 37.78866 383.992245 42.21126 379.43451 26.38818 345.048795 24.999975 319.9014 36.990135 303.39036 20.1474 276.04395 28.82061 266.596785 9.742005 203.61159 -2.84217094e-13 134.729595 35.47908 128.071125 84.434805 109.791045 87.07608 89.53308 113.46426 96.154695 134.803305 88.071165 136.6092 68.660865 168.86961 74.115405 179.103015 22.960665 197.88678 0.110565 224.27496 2.002455 255.94569 42.985215 277.333875 42.567525 304.20117 73.230885 319.26258 94.557645 316.621305 123.501105 292.8744 156.97773 279.68031 214.901505 242.7516 249.078375 227.579625 317.186415 185.33151 347.44437 174.139875 397.71459 134.56989 418.488525 126.646065z"
                  />
                  <path
                    fill="#FFF"
                    d="M397.71459 134.56989L418.488525 126.646065 429.70473 100.257885 400.51557 77.899185 390.282165 84.434805 377.751465 80.19648 347.432085 97.628895 323.427195 80.823015 292.591845 96.48639 291.043935 59.09085 257.61645 60.6879 216.252855 79.152255 184.287285 124.017075 192.84993 150.39297 171.54774 175.25781 154.61901 202.198815 123.501105 207.014535 108.86967 254.852325 82.370925 263.85723 78.57486 282.321585 80.66331 307.284705 94.557645 316.621305 123.501105 292.8744 156.97773 279.68031 214.901505 242.7516 251.461665 224.27496 310.88421 188.464185 347.44437 171.510885z"
                  />
                  <path
                    fill="#344960"
                    d="M87.334065 303.36579L85.614165 282.739275 88.40286 269.176635 114.4962 260.306865 128.89422 213.230745 158.832765 208.611585 177.17427 179.397855 200.700045 151.96545 192.002265 125.196435 220.83516 84.754215 259.26264 67.59207 284.37318 66.400425 286.080795 107.628885 322.862085 88.931115 347.063535 105.884415 378.50085 87.81318 391.215825 92.11293 400.159305 86.400405 421.166655 102.50604 413.230545 121.191525 391.25268 129.55761 343.574595 170.921205 307.604115 189.09072 246.572235 223.21845 211.756545 236.48625 153.78363 273.43953 119.92617 286.793325 94.139955 307.948095z"
                  />
                  <path
                    fill="url(#a)"
                    d="M87.334065 303.36579L85.614165 282.739275 88.40286 269.176635 114.4962 260.306865 128.89422 213.230745 153.78363 273.43953 119.92617 286.793325 94.139955 307.948095z"
                  />
                  <path
                    fill="url(#b)"
                    d="M418.488525 126.646065L429.70473 100.257885 443.402505 71.240715 440.282115 107.039205z"
                  />
                  <path
                    fill="#E2E2E2"
                    d="M443.402505 71.240715L429.70473 100.257885 400.51557 77.899185z"
                  />
                  <path
                    fill="#F7F7F7"
                    d="M400.51557 77.899185L396.51066 58.046625 414.7416 37.78866 443.402505 71.240715z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M400.51557 77.899185L390.282165 84.434805 396.51066 58.046625z"
                  />
                  <path
                    fill="url(#c)"
                    d="M396.51066 58.046625L377.751465 80.19648 390.282165 84.434805z"
                  />
                  <path
                    fill="url(#d)"
                    d="M396.51066 58.046625L354.385395 50.135085 377.751465 80.19648z"
                  />
                  <path
                    fill="#E2E2E2"
                    d="M347.432085 97.628895L377.751465 80.19648 342.87435 85.147335z"
                  />
                  <path
                    fill="url(#e)"
                    d="M323.427195 80.823015L291.658185 73.88199 292.591845 96.48639z"
                  />
                  <path
                    fill="#E8E8E8"
                    d="M291.043935 59.09085L266.596785 9.742005 214.901505 32.149845 257.61645 60.6879z"
                  />
                  <path
                    fill="url(#f)"
                    d="M291.658185 73.88199L291.043935 59.09085 284.66802 46.228455 330.19623 47.49381 323.427195 80.823015z"
                  />
                  <path
                    fill="url(#g)"
                    d="M284.66802 46.228455L303.39036 20.1474 276.04395 28.82061z"
                  />
                  <path
                    fill="url(#h)"
                    d="M342.87435 85.147335L324.581985 75.122775 323.427195 80.823015 347.432085 97.628895z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M354.385395 50.135085L325.908765 68.59944 324.581985 75.122775 342.87435 85.147335 377.751465 80.19648z"
                  />
                  <path
                    fill="url(#i)"
                    d="M379.43451 26.38818L388.10772 56.474145 375.45417 54.090855 352.84977 40.0491z"
                  />
                  <path
                    fill="url(#j)"
                    d="M414.7416 37.78866L396.51066 58.046625 388.10772 56.474145 383.992245 42.21126z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M352.84977 40.0491L345.048795 24.999975 379.43451 26.38818z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M303.39036 20.1474L330.19623 47.49381 284.66802 46.228455z"
                  />
                  <path
                    fill="url(#k)"
                    d="M345.048795 24.999975L319.9014 36.990135 324.25029 41.42502 352.84977 40.0491z"
                  />
                  <path
                    fill="url(#l)"
                    d="M352.84977 40.0491L345.491055 55.909035 325.908765 68.59944 330.19623 47.49381 324.25029 41.42502z"
                  />
                  <path
                    fill="url(#m)"
                    d="M345.491055 55.909035L352.84977 40.0491 375.45417 54.090855 354.385395 50.135085z"
                  />
                  <path
                    fill="#E2E2E2"
                    d="M214.901505 32.149845L203.61159 7.10542736e-14 266.596785 9.742005z"
                  />
                  <path
                    fill="#E2E2E2"
                    d="M257.61645 60.6879L214.901505 32.149845 157.93596 80.19648 216.252855 79.152255z"
                  />
                  <path
                    fill="url(#n)"
                    d="M203.61159 3.33066907e-14L134.729595 35.47908 214.901505 32.149845z"
                  />
                  <path
                    fill="url(#o)"
                    d="M157.93596 80.19648L134.729595 35.47908 214.901505 32.149845z"
                  />
                  <path
                    fill="url(#p)"
                    d="M216.252855 79.152255L184.287285 124.017075 153.51336 114.64362 157.93596 80.19648z"
                  />
                  <path
                    fill="url(#q)"
                    d="M124.852455 108.18171L157.93596 80.19648 134.729595 35.47908z"
                  />
                  <path
                    fill="url(#r)"
                    d="M124.852455 108.18171L109.791045 87.07608 128.071125 84.434805z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M153.51336 114.64362L128.071125 134.56989 154.56987 138.35367 184.287285 124.017075z"
                  />
                  <path
                    fill="url(#s)"
                    d="M157.93596 80.19648L153.51336 114.64362 140.331555 124.96302 124.852455 108.18171z"
                  />
                  <path
                    fill="url(#t)"
                    d="M140.331555 124.96302L113.206275 124.96302 88.071165 136.6092 106.1424 165.245535 126.16695 159.63129 131.40036 153.034245 128.071125 134.56989z"
                  />
                  <path
                    fill="url(#u)"
                    d="M140.331555 124.96302L113.206275 124.96302 95.62644 133.107975 89.53308 113.46426 124.852455 108.18171z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M109.791045 87.07608L89.53308 113.46426 124.852455 108.18171z"
                  />
                  <path
                    fill="url(#v)"
                    d="M154.56987 138.35367L192.84993 150.39297 184.287285 124.017075z"
                  />
                  <path
                    fill="url(#w)"
                    d="M154.56987 138.35367L171.54774 175.25781 192.84993 150.39297z"
                  />
                  <path
                    fill="url(#x)"
                    d="M128.071125 134.56989L131.40036 153.034245 171.54774 175.25781 154.56987 138.35367z"
                  />
                  <path
                    fill="#E2E2E2"
                    d="M96.080985 168.071085L123.501105 207.014535 154.61901 202.198815 171.54774 175.25781 126.16695 159.63129z"
                  />
                  <path
                    fill="url(#y)"
                    d="M96.080985 168.071085L75.933585 215.442045 123.501105 207.014535z"
                  />
                  <path
                    fill="url(#z)"
                    d="M68.660865 168.86961L93.501135 174.139875 96.080985 168.071085 106.1424 165.245535 88.071165 136.6092z"
                  />
                  <path
                    fill="url(#A)"
                    d="M83.722275 197.137395L68.660865 168.86961 93.501135 174.139875z"
                  />
                  <path
                    fill="url(#B)"
                    d="M75.933585 215.442045L108.86967 254.852325 123.501105 207.014535z"
                  />
                  <path
                    fill="url(#C)"
                    d="M93.41514 236.3634L64.090845 241.338825 82.370925 263.85723 108.86967 254.852325z"
                  />
                  <path
                    fill="#F7F7F7"
                    d="M64.090845 241.338825L43.230915 261.215955 78.57486 282.321585 82.370925 263.85723z"
                  />
                  <path
                    fill="url(#D)"
                    d="M79.103115 188.464185L52.960635 223.623855 87.4692 229.250385 75.933585 215.442045 83.722275 197.137395z"
                  />
                  <path
                    fill="url(#E)"
                    d="M51.535575 253.304415L52.960635 223.623855 87.4692 229.250385 93.41514 236.3634 64.090845 241.338825z"
                  />
                  <path
                    fill="url(#F)"
                    d="M74.115405 179.103015L22.960665 197.88678 52.960635 223.623855 79.103115 188.464185z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M2.002455 255.94569L22.960665 197.88678 52.960635 223.623855z"
                  />
                  <path
                    fill="url(#G)"
                    d="M52.960635 223.623855L51.535575 253.304415 43.230915 261.215955 42.985215 277.333875 2.002455 255.94569z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M43.230915 261.215955L42.567525 304.20117 78.57486 282.321585z"
                  />
                  <path
                    fill="url(#H)"
                    d="M73.230885 319.26258L80.66331 307.284705 78.57486 282.321585 42.567525 304.20117z"
                  />
                  <path
                    fill="url(#I)"
                    d="M94.557645 316.621305L80.66331 307.284705 73.230885 319.26258z"
                  />
                  <path
                    fill="url(#J)"
                    d="M2.002455 255.94569L0.110565 224.27496 22.960665 197.88678z"
                  />
                  <path
                    fill="url(#K)"
                    d="M131.40036 153.034245L126.16695 159.63129 154.61901 202.198815 171.54774 175.25781z"
                  />
                  <path
                    fill="url(#L)"
                    d="M113.206275 124.96302L120.24558 149.545305 130.650975 148.8942 128.071125 134.56989 140.331555 124.96302z"
                  />
                  <path
                    fill="url(#M)"
                    d="M120.24558 149.545305L113.206275 163.26765 126.16695 159.63129 131.40036 153.034245 130.650975 148.8942z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M216.252855 79.152255L214.901505 32.149845 257.61645 60.6879z"
                  />
                  <image
                    x={390.663}
                    y={57.61665}
                    width={109.3365}
                    height={113.022}
                    xlinkHref="data:image/png;base64,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"
                  />
                  <path
                    fill="url(#N)"
                    transform="rotate(11 445.565 114.066)"
                    d="M435.638385 125.47899L449.053605 116.842635 455.490945 102.65346 453.04623 119.913885z"
                  />
                </g>
                <g transform="matrix(-1 0 0 1 1241 27) translate(491.95 95.76)">
                  <mask id="P" fill="#fff">
                    <use xlinkHref="#O" />
                  </mask>
                  <g mask="url(#P)">
                    <g transform="translate(-27.618 -22.341)">
                      <path
                        fill="#097496"
                        d="M271.86705 148.619015L201.03174 107.72225 201.03174 90.486395 271.86705 66.825485 342.690075 90.486395 342.690075 107.72225z"
                      />
                      <path
                        fill="url(#Q)"
                        d="M271.86705 148.619015L201.03174 107.72225 201.03174 90.486395 271.86705 66.825485 342.690075 90.486395 342.690075 107.72225z"
                      />
                      <path
                        fill="url(#R)"
                        d="M271.86705 131.38316L201.03174 90.486395 271.86705 49.58963 342.690075 90.486395z"
                      />
                      <image
                        y={0.10565}
                        width={217.4445}
                        height={163.3905}
                        xlinkHref="data:image/png;base64,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"
                        opacity={0.6}
                        transform="translate(163.39 8.6)"
                      />
                      <path
                        fill="#1D8DBA"
                        d="M271.86705 131.38316L271.86705 148.619015 342.690075 107.72225 342.690075 90.486395z"
                      />
                      <path
                        fill="url(#S)"
                        d="M271.86705 131.38316L271.86705 148.619015 342.690075 107.72225 342.690075 90.486395z"
                      />
                      <path
                        fill="url(#T)"
                        d="M271.86705 104.30702L271.86705 121.53059 342.690075 80.633825 342.690075 63.410255z"
                      />
                      <path
                        fill="#097496"
                        d="M271.86705 121.53059L201.03174 80.633825 201.03174 63.410255 271.86705 39.749345 342.690075 63.410255 342.690075 80.633825z"
                      />
                      <path
                        fill="url(#U)"
                        d="M271.86705 121.53059L201.03174 80.633825 201.03174 63.410255 271.86705 39.749345 342.690075 63.410255 342.690075 80.633825z"
                      />
                      <path
                        fill="url(#V)"
                        d="M271.86705 104.30702L201.03174 63.410255 271.86705 22.51349 342.690075 63.410255z"
                      />
                      <path
                        fill="url(#W)"
                        d="M271.86705 104.30702L201.03174 63.410255 271.86705 22.51349 342.690075 63.410255z"
                      />
                      <path
                        fill="#1D8DBA"
                        d="M271.86705 104.30702L271.86705 121.53059 342.690075 80.633825 342.690075 63.410255z"
                      />
                      <path
                        fill="url(#X)"
                        d="M271.86705 104.30702L271.86705 121.53059 342.690075 80.633825 342.690075 63.410255z"
                      />
                      <path
                        fill="#097496"
                        d="M189.63126 196.186535L118.79595 155.28977 118.79595 138.053915 189.63126 114.393005 260.46657 138.053915 260.46657 155.28977z"
                      />
                      <path
                        fill="url(#Y)"
                        d="M189.63126 196.186535L118.79595 155.28977 118.79595 138.053915 189.63126 114.393005 260.46657 138.053915 260.46657 155.28977z"
                      />
                      <path
                        fill="url(#Z)"
                        d="M189.63126 178.95068L118.79595 138.053915 189.63126 97.169435 260.46657 138.053915z"
                      />
                      <image
                        y={0.10565}
                        width={214.9875}
                        height={162.162}
                        xlinkHref="data:image/png;base64,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"
                        opacity={0.6}
                        transform="translate(82.31 56.511)"
                      />
                      <path
                        fill="#1D8DBA"
                        d="M189.63126 178.95068L189.63126 196.186535 260.46657 155.28977 260.46657 138.053915z"
                      />
                      <path
                        fill="url(#aa)"
                        d="M189.63126 178.95068L189.63126 196.186535 260.46657 155.28977 260.46657 138.053915z"
                      />
                      <path
                        fill="#097496"
                        d="M189.63126 169.110395L118.79595 128.21363 118.79595 110.977775 189.63126 87.316865 260.46657 110.977775 260.46657 128.21363z"
                      />
                      <path
                        fill="url(#ab)"
                        d="M189.63126 169.110395L118.79595 128.21363 118.79595 110.977775 189.63126 87.316865 260.46657 110.977775 260.46657 128.21363z"
                      />
                      <path
                        fill="url(#ac)"
                        d="M189.63126 151.87454L118.79595 110.977775 189.63126 70.08101 260.46657 110.977775z"
                      />
                      <path
                        fill="#1D8DBA"
                        d="M189.63126 151.87454L189.63126 169.110395 260.46657 128.21363 260.46657 110.977775z"
                      />
                      <path
                        fill="url(#ad)"
                        d="M189.63126 151.87454L189.63126 169.110395 260.46657 128.21363 260.46657 110.977775z"
                      />
                      <path
                        fill="#097496"
                        d="M107.407755 243.336365L36.572445 202.4396 36.572445 185.203745 107.407755 161.542835 178.243065 185.203745 178.243065 202.4396z"
                      />
                      <path
                        fill="url(#ae)"
                        d="M107.407755 243.336365L36.572445 202.4396 36.572445 185.203745 107.407755 161.542835 178.243065 185.203745 178.243065 202.4396z"
                      />
                      <path
                        fill="url(#af)"
                        d="M107.407755 226.10051L36.572445 185.203745 107.407755 144.30698 178.243065 185.203745z"
                      />
                      <image
                        y={0.10565}
                        width={214.9875}
                        height={162.162}
                        xlinkHref="data:image/png;base64,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"
                        opacity={0.6}
                        transform="translate(0 103.194)"
                      />
                      <path
                        fill="#1D8DBA"
                        d="M107.407755 226.10051L107.407755 243.336365 178.243065 202.4396 178.243065 185.203745z"
                      />
                      <path
                        fill="url(#ag)"
                        d="M107.407755 226.10051L107.407755 243.336365 178.243065 202.4396 178.243065 185.203745z"
                      />
                      <path
                        fill="#097496"
                        d="M107.407755 216.24794L36.572445 175.351175 36.572445 158.127605 107.407755 134.45441 178.243065 158.127605 178.243065 175.351175z"
                      />
                      <path
                        fill="url(#ah)"
                        d="M107.407755 216.24794L36.572445 175.351175 36.572445 158.127605 107.407755 134.45441 178.243065 158.127605 178.243065 175.351175z"
                      />
                      <path
                        fill="url(#ai)"
                        d="M107.407755 199.012085L36.572445 158.127605 107.407755 117.23084 178.243065 158.127605z"
                      />
                      <path
                        fill="url(#aj)"
                        d="M107.407755 199.012085L36.572445 158.127605 107.407755 117.23084 178.243065 158.127605z"
                      />
                      <path
                        fill="#1D8DBA"
                        d="M107.407755 199.012085L107.407755 216.24794 178.243065 175.351175 178.243065 158.127605z"
                      />
                      <path
                        fill="url(#ak)"
                        d="M107.407755 199.012085L107.407755 216.24794 178.243065 175.351175 178.243065 158.127605z"
                      />
                      <image
                        x={-5.68434189e-13}
                        y={0.10565}
                        width={218.673}
                        height={163.3905}
                        xlinkHref="data:image/png;base64,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"
                        opacity={0.6}
                        transform="translate(79.853 27.027)"
                      />
                      <path
                        fill="#097496"
                        d="M189.63126 142.02197L118.79595 101.125205 118.79595 83.901635 189.63126 60.22844 260.46657 83.901635 260.46657 101.125205z"
                      />
                      <path
                        fill="url(#al)"
                        d="M189.63126 142.02197L118.79595 101.125205 118.79595 83.901635 189.63126 60.22844 260.46657 83.901635 260.46657 101.125205z"
                      />
                      <path
                        fill="url(#am)"
                        d="M189.63126 124.7984L118.79595 83.901635 189.63126 43.00487 260.46657 83.901635z"
                      />
                      <image
                        x={-5.68434189e-13}
                        y={0.10565}
                        width={218.673}
                        height={164.619}
                        xlinkHref="data:image/png;base64,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"
                        opacity={0.6}
                        transform="translate(79.853)"
                      />
                      <path
                        fill="#1D8DBA"
                        d="M189.63126 124.7984L189.63126 142.02197 260.46657 101.125205 260.46657 83.901635z"
                      />
                      <path
                        fill="url(#an)"
                        d="M189.63126 124.7984L189.63126 142.02197 260.46657 101.125205 260.46657 83.901635z"
                      />
                      <path
                        fill="#097496"
                        d="M189.63126 114.94583L118.79595 74.049065 118.79595 56.81321 189.63126 33.1523 260.46657 56.81321 260.46657 74.049065z"
                      />
                      <path
                        fill="url(#ao)"
                        d="M189.63126 114.94583L118.79595 74.049065 118.79595 56.81321 189.63126 33.1523 260.46657 56.81321 260.46657 74.049065z"
                      />
                      <path
                        fill="url(#ap)"
                        d="M189.63126 97.709975L118.79595 56.81321 189.63126 15.916445 260.46657 56.81321z"
                      />
                      <path
                        fill="url(#aq)"
                        d="M189.63126 97.709975L118.79595 56.81321 189.63126 15.916445 260.46657 56.81321z"
                      />
                      <path
                        fill="#1D8DBA"
                        d="M189.63126 97.709975L189.63126 114.94583 260.46657 74.049065 260.46657 56.81321z"
                      />
                      <path
                        fill="url(#ar)"
                        d="M189.63126 97.709975L189.63126 114.94583 260.46657 74.049065 260.46657 56.81321z"
                      />
                    </g>
                    <g transform="translate(-27.618 -22.341) translate(112.089 63.473)">
                      <path
                        d="M189.803 28.095v7.85c-.012.367-.188.71-.48.934l-24.09 13.906c-.27.148-.48 0-.48-.368v-7.838c0-.37.178-.719.48-.934l24.09-13.906c.27-.16.48.012.48.356z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M189.803 28.095v7.85c-.012.367-.188.71-.48.934l-24.09 13.906c-.27.148-.48 0-.48-.368v-7.838c0-.37.178-.719.48-.934l24.09-13.906c.27-.16.48.012.48.356z"
                        fill="url(#as)"
                      />
                      <path
                        d="M189.803 28.095v7.85c-.012.367-.188.71-.48.934l-24.09 13.906c-.27.148-.48 0-.48-.368v-1.524l22.593-13.046c.296-.222.476-.565.491-.934v-6.314l1.487-.86c.27-.16.479.012.479.356z"
                        fill="#097496"
                      />
                      <path
                        d="M226.105 9.63L194.41 27.935c-.27.16-.492 0-.492-.368v-1.843c.015-.37.196-.712.492-.934l31.695-18.292c.27-.16.491 0 .491.368v1.83a1.143 1.143 0 01-.491.934z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M226.105 15.638L194.41 33.943c-.27.16-.492 0-.492-.369v-1.83c.012-.374.192-.722.492-.946l31.695-18.293c.27-.16.491 0 .491.369v1.83a1.143 1.143 0 01-.491.934z"
                        fill="#00EDB5"
                      />
                      <path d="M189.803 28.095v7.85c-.012.367-.188.71-.48.934l-24.09 13.906c-.27.148-.48 0-.48-.368v-7.838c0-.37.178-.719.48-.934l24.09-13.906c.27-.16.48.012.48.356z" />
                      <path d="M189.803 28.095v7.85c-.012.367-.188.71-.48.934l-24.09 13.906c-.27.148-.48 0-.48-.368v-1.524l22.593-13.046c.296-.222.476-.565.491-.934v-6.314l1.487-.86c.27-.16.479.012.479.356zM226.105 9.63L194.41 27.935c-.27.16-.492 0-.492-.368v-1.843c.015-.37.196-.712.492-.934l31.695-18.292c.27-.16.491 0 .491.368v1.83a1.143 1.143 0 01-.491.934zM226.105 15.638L194.41 33.943c-.27.16-.492 0-.492-.369v-1.83c.012-.374.192-.722.492-.946l31.695-18.293c.27-.16.491 0 .491.369v1.83a1.143 1.143 0 01-.491.934z" />
                      <path
                        d="M189.803 55.183v7.85c-.012.368-.188.71-.48.934l-24.09 13.907c-.27.147-.48 0-.48-.381v-7.838c.002-.37.18-.717.48-.934l24.09-13.906c.27-.123.48.012.48.368z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M189.803 55.183v7.85c-.012.368-.188.71-.48.934l-24.09 13.907c-.27.147-.48 0-.48-.381v-7.838c.002-.37.18-.717.48-.934l24.09-13.906c.27-.123.48.012.48.368z"
                        fill="url(#at)"
                      />
                      <path
                        d="M189.803 55.183v7.85c-.012.368-.188.71-.48.934l-24.09 13.907c-.27.147-.48 0-.48-.381v-1.511l22.593-13.047c.296-.221.476-.564.491-.934v-6.326l1.487-.86c.27-.123.479.012.479.368z"
                        fill="#097496"
                      />
                      <path
                        d="M226.105 36.719L194.41 55.024c-.27.147-.492 0-.492-.381v-1.83c.015-.37.196-.713.492-.934l31.695-18.293c.27-.16.491 0 .491.369v1.83c-.015.37-.195.712-.491.934z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M226.105 42.726L194.41 61.031c-.27.147-.492 0-.492-.369V58.82c.015-.37.196-.713.492-.934l31.695-18.292c.27-.16.491 0 .491.368v1.83c-.015.37-.195.713-.491.934z"
                        fill="#00EDB5"
                      />
                      <path
                        d="M107.309 75.896v7.838c-.012.367-.188.71-.48.933L82.74 98.574c-.27.16-.48 0-.48-.369v-7.887c0-.37.178-.718.48-.933l24.09-13.809c.271-.208.48 0 .48.32z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M107.309 75.896v7.838c-.012.367-.188.71-.48.933L82.74 98.574c-.27.16-.48 0-.48-.369v-7.887c0-.37.178-.718.48-.933l24.09-13.809c.271-.208.48 0 .48.32z"
                        fill="url(#au)"
                      />
                      <path
                        d="M107.309 75.896v7.838c-.012.367-.188.71-.48.933L82.74 98.574c-.27.16-.48 0-.48-.369v-1.523l22.593-13.047c.296-.221.476-.564.491-.933v-6.315l1.487-.86c.27-.16.479.05.479.369z"
                        fill="#097496"
                      />
                      <path
                        d="M143.611 57.42l-31.695 18.304c-.27.16-.492 0-.492-.369v-1.83c.012-.374.193-.722.492-.946l31.695-18.293c.27-.16.492 0 .492.369v1.83a1.143 1.143 0 01-.492.934z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M143.611 63.439l-31.695 18.28c-.27.16-.492 0-.492-.369v-1.83c.002-.373.186-.721.492-.934l31.695-18.304c.27-.16.492 0 .492.368v1.83a1.228 1.228 0 01-.492.959z"
                        fill="#00EDB5"
                      />
                      <path
                        d="M107.309 48.758v7.85c-.012.368-.188.71-.48.934L82.74 71.449c-.27.147-.48 0-.48-.381V63.29c.002-.37.18-.717.48-.933l24.09-13.907c.271-.221.48-.049.48.307z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M107.309 48.758v7.85c-.012.368-.188.71-.48.934L82.74 71.449c-.27.147-.48 0-.48-.381V63.29c.002-.37.18-.717.48-.933l24.09-13.907c.271-.221.48-.049.48.307z"
                        fill="url(#av)"
                      />
                      <path
                        d="M107.309 48.758v7.85c-.012.368-.188.71-.48.934L82.74 71.449c-.27.147-.48 0-.48-.381v-1.511l22.593-13.047c.296-.221.476-.564.491-.934V49.25l1.487-.86c.27-.16.479.012.479.368z"
                        fill="#097496"
                      />
                      <path
                        d="M143.611 30.294l-31.695 18.255c-.27.16-.492 0-.492-.368v-1.83c.015-.37.196-.713.492-.934l31.695-18.293c.27-.16.492 0 .492.369v1.83a1.228 1.228 0 01-.492.97z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M143.611 36.264L111.916 54.57c-.27.147-.492 0-.492-.38v-1.831c.015-.37.196-.712.492-.934l31.695-18.292c.27-.16.492 0 .492.368v1.83c-.015.37-.196.713-.492.934z"
                        fill="#00EDB5"
                      />
                      <path
                        d="M107.309 21.633v7.838c-.008.371-.185.72-.48.946L82.74 44.31c-.27.16-.48 0-.48-.368v-7.838c0-.37.178-.719.48-.934l24.09-13.907c.271-.16.48.013.48.369z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M107.309 21.633v7.838c-.008.371-.185.72-.48.946L82.74 44.31c-.27.16-.48 0-.48-.368v-7.838c0-.37.178-.719.48-.934l24.09-13.907c.271-.16.48.013.48.369z"
                        fill="url(#aw)"
                      />
                      <path
                        d="M107.309 21.633v7.838c-.008.371-.185.72-.48.946L82.74 44.31c-.27.16-.48 0-.48-.368v-1.536l22.593-13.047c.296-.221.476-.564.491-.933v-6.315l1.487-.86c.27-.147.479.025.479.38z"
                        fill="#097496"
                      />
                      <path
                        d="M143.611 3.169l-31.695 18.353c-.27.16-.492 0-.492-.368v-1.83c.002-.373.186-.722.492-.934L143.61.085c.27-.16.492 0 .492.369v1.83c-.03.352-.209.674-.492.885z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M143.611 9.237L111.916 27.53c-.27.16-.492 0-.492-.369v-1.83c.002-.373.186-.722.492-.934L143.61 6.092c.27-.16.492 0 .492.369v1.843c-.015.369-.196.712-.492.933z"
                        fill="#00EDB5"
                      />
                      <path
                        d="M107.309 102.972v7.85c-.012.367-.188.71-.48.934l-24.09 13.906c-.27.148-.48 0-.48-.38v-7.826c.01-.372.185-.72.48-.946l24.09-13.907c.271-.16.48 0 .48.369z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M107.309 102.972v7.85c-.012.367-.188.71-.48.934l-24.09 13.906c-.27.148-.48 0-.48-.38v-7.826c.01-.372.185-.72.48-.946l24.09-13.907c.271-.16.48 0 .48.369z"
                        fill="url(#ax)"
                      />
                      <path fill="url(#ay)" d="M82.7390025 116.509995L106.829888 102.61566" />
                      <path
                        d="M107.309 102.972v7.85c-.012.367-.188.71-.48.934l-24.09 13.906c-.27.148-.48 0-.48-.38v-1.512l22.593-13.046c.296-.222.476-.565.491-.934v-6.314l1.487-.86c.27-.172.479-.013.479.356z"
                        fill="#097496"
                      />
                      <path
                        d="M143.611 84.508l-31.695 18.304c-.27.148-.492 0-.492-.368V100.6c.015-.37.196-.712.492-.934l31.695-18.292c.27-.16.492 0 .492.368v1.83c-.015.37-.196.713-.492.935z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M143.611 90.515l-31.695 18.305c-.27.147-.492 0-.492-.369v-1.843c.015-.369.196-.712.492-.933l31.695-18.293c.27-.16.492 0 .492.369v1.83a1.143 1.143 0 01-.492.934z"
                        fill="#00EDB5"
                      />
                      <path
                        d="M25.16 123.046v7.813c-.01.371-.185.72-.48.946L.59 145.724c-.271.16-.48 0-.48-.369v-7.838c-.001-.37.178-.718.48-.933l24.09-13.907c.27-.16.48.012.48.369z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M25.16 123.046v7.813c-.01.371-.185.72-.48.946L.59 145.724c-.271.16-.48 0-.48-.369v-7.838c-.001-.37.178-.718.48-.933l24.09-13.907c.27-.16.48.012.48.369z"
                        fill="url(#aw)"
                      />
                      <path
                        d="M25.16 123.046v7.813c-.01.371-.185.72-.48.946L.59 145.724c-.271.16-.48 0-.48-.369v-1.523l22.592-13.047c.296-.221.477-.564.492-.933v-6.364l1.486-.86c.27-.11.48.061.48.418z"
                        fill="#097496"
                      />
                      <path
                        d="M61.461 104.581l-31.695 18.293c-.27.16-.491 0-.491-.369v-1.83c.001-.373.185-.722.491-.934l31.695-18.305c.27-.16.492 0 .492.369v1.843c-.015.369-.196.712-.492.933z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M61.461 110.589L29.766 128.88c-.27.16-.491 0-.491-.369v-1.83c.001-.373.185-.721.491-.934l31.695-18.304c.27-.148.492 0 .492.368v1.843c-.015.37-.196.712-.492.934z"
                        fill="#00EDB5"
                      />
                      <path
                        d="M25.16 150.122v7.85c-.013.367-.189.71-.48.934L.59 172.812c-.271.148-.48 0-.48-.38v-7.826c.008-.372.185-.72.48-.946l24.09-13.895c.27-.16.48.013.48.357z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M25.16 150.122v7.85c-.013.367-.189.71-.48.934L.59 172.812c-.271.148-.48 0-.48-.38v-7.826c.008-.372.185-.72.48-.946l24.09-13.895c.27-.16.48.013.48.357z"
                        fill="url(#az)"
                      />
                      <path
                        d="M25.16 150.122v7.85c-.013.367-.189.71-.48.934L.59 172.812c-.271.148-.48 0-.48-.38v-1.512l22.592-13.034c.296-.222.477-.564.492-.934v-6.314l1.486-.86c.27-.172.48 0 .48.344z"
                        fill="#097496"
                      />
                      <path
                        d="M61.461 131.657l-31.695 18.305c-.27.147-.491 0-.491-.368v-1.843c.015-.37.195-.712.491-.934l31.695-18.292c.27-.16.492 0 .492.368v1.83a1.143 1.143 0 01-.492.934z"
                        fill="#94F5A9"
                      />
                      <path
                        d="M61.461 137.665l-31.695 18.304c-.27.16-.491 0-.491-.368v-1.843c.015-.37.195-.712.491-.934l31.695-18.28c.27-.16.492 0 .492.369v1.83a1.143 1.143 0 01-.492.922z"
                        fill="#00EDB5"
                      />
                    </g>
                  </g>
                </g>
                <g transform="matrix(-1 0 0 1 1241 27) translate(.205 .232)" fillRule="nonzero">
                  <path
                    d="M.557 122.617l276.238 71.56 125.122-17.641 130.546 12.285 5.582 8.44-25.802 13.98-71.277-11.548-161.194 5.529L.557 122.617zm897.511-90.524l150.858 30.345 191.585-26.86-204.87 42.715-129.253-30.659L840.643 89.7 822.11 68.169l75.959-36.076z"
                    fill="url(#aA)"
                  />
                  <path
                    fill="url(#aB)"
                    filter="url(#aC)"
                    transform="rotate(67 235.682 200.663)"
                    d="M175.073536 252.315677L264.85404 210.485252 296.291006 149.011112 267.818565 219.146177z"
                  />
                  <path
                    fill="url(#aD)"
                    transform="rotate(35 1033.898 87.754)"
                    d="M1001.21556 109.933443L1027.30341 109.848974 1047.21233 101.120395 1066.5798 62.1323161 1049.85589 109.848974 1040.29392 111.780581 1009.95753 113.376602z"
                  />
                  <path
                    fill="url(#aD)"
                    filter="url(#aE)"
                    transform="rotate(30 1034.116 84.594)"
                    d="M1001.43425 106.772817L1027.5221 106.688348 1047.43102 97.9597695 1066.79849 58.9716904 1050.07457 106.688348 1040.51261 108.619955 1010.17622 110.215977z"
                  />
                  <path
                    fill="url(#aB)"
                    transform="rotate(64 235.682 200.663)"
                    d="M175.073536 252.315677L264.85404 210.485252 296.291006 149.011112 267.818565 219.146177z"
                  />
                  <path
                    fill="url(#aF)"
                    opacity={0.6429734}
                    filter="url(#aG)"
                    transform="rotate(-5 469.613 314.366)"
                    d="M423.523946 293.194177L423.122153 310.810867 453.198761 334.3028 530.055462 331.547947 452.096146 343.104639 416.023111 323.882107 409.171175 285.626617z"
                  />
                  <path
                    fill="url(#aF)"
                    d="M423.523946 293.194177L423.122153 310.810867 453.198761 334.3028 530.055462 331.547947 452.096146 343.104639 416.023111 323.882107 409.171175 285.626617z"
                  />
                  <path
                    fill="url(#aH)"
                    filter="url(#aI)"
                    transform="rotate(-5 939.835 57.093)"
                    d="M968.145726 38.4834319L932.686885 41.0280105 911.524257 75.7031428 936.048683 44.8910672 956.622492 42.1629334z"
                  />
                  <path
                    fill="url(#aH)"
                    d="M965.884208 35.4146577L930.425367 37.9592363 909.262739 72.6343687 933.787165 41.822293 954.360974 39.0941592z"
                  />
                  <path
                    fill="url(#aJ)"
                    opacity={0.45140439}
                    filter="url(#aK)"
                    d="M579.479119 17.3345018L630.341916 0.674236328 735.414693 69.6071768 634.971858 12.3401875 621.815276 18.5630018 609.831991 16.8185318 547.015852 61.3393718z"
                  />
                  <path
                    fill="url(#aJ)"
                    d="M579.479119 29.6195018L630.341916 12.9592363 735.414693 81.8921768 634.971858 24.6251875 621.815276 30.8480018 609.831991 29.1035318 547.015852 61.3393718z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div className={style.buttonContainer}>
            <h1 className={style.buttonText}>We’ve got you covered.</h1>
            <Button
              variant="secondary"
              className={style.button}
              label="Talk To Our Office Experts"
              onClick={() => setShowModal(true)}
            />
            <div className={style.pathContainer}>
              <svg
                width={162}
                height={272}
                viewBox="0 0 162 272"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>D7C9F06D-97D5-449D-9D98-7716CD21A467</title>
                <g stroke="#04EAAE" fill="none" fillRule="evenodd">
                  <path opacity={0.231} d="M0 1h82v270H41" />
                  <path opacity={0.24} d="M82 136.5l79.585.059" />
                </g>
              </svg>
            </div>
            <div className={style.servicesContainer}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <div className={style.oval} />
                <h1 className={style.serviceText}>Discounted Licensing</h1>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <div className={style.oval} />
                <h1 className={style.serviceText}>Office Migration</h1>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <div className={style.oval} />
                <h1 className={style.serviceText}>Data Backup &amp; Recovery</h1>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <div className={style.oval} />
                <h1 className={style.serviceText}>Security</h1>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <div className={style.oval} />
                <h1 className={style.serviceText}>E-Mail Security Training</h1>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <div className={style.oval} />
                <h1 className={style.serviceText}>Managed Service Offerings</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal ? (
        <ContactModal
          showClose
          shouldCloseOnOverlayClick
          onClose={() => setShowModal(false)}
          onDismiss={() => setShowModal(false)}
          isOpen={showModal}
          closeButtonPosition="right"
          ariaHideApp={false}
          success={isSuccessful}
        >
          <ContactForm
            showLogo
            headerTitle="Contact Us"
            buttonLabel="Send"
            ctaIntentSuffix="modal-office-provided-services-cta"
            inquiryPlaceholder="Let's talk about Office 365."
            isLandingPageForm
            isSuccessfulCallback={(v) => {
              setIsSuccessful(v)
              if (!v) {
                setShowModal(false)
              }
            }}
          />
        </ContactModal>
      ) : null}
    </section>
  )
}

export default ProvidedServices
